import { render, staticRenderFns } from "./DInventory.vue?vue&type=template&id=3cbaf0a6&scoped=true&"
import script from "./DInventory.vue?vue&type=script&lang=js&"
export * from "./DInventory.vue?vue&type=script&lang=js&"
import style0 from "./DInventory.vue?vue&type=style&index=0&id=3cbaf0a6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3cbaf0a6",
  null
  
)

export default component.exports